import { FC } from "react"
import { Outlet } from "react-router-dom"
import { ModalsRouter } from "modals/index"
import { PageSuspense } from "ui/@page/ui/page-suspense"

interface IRootTemplate {}

export const RootTemplate: FC<IRootTemplate> = () => {
  return (
    <PageSuspense>
      <ModalsRouter />
      <Outlet />
    </PageSuspense>
  )
}
